let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3d8Qb")).then(() => parcelRequire('drL7k'));